/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MessageTypeEnum } from './MessageTypeEnum';
import {
    MessageTypeEnumFromJSON,
    MessageTypeEnumFromJSONTyped,
    MessageTypeEnumToJSON,
    MessageTypeEnumToJSONTyped,
} from './MessageTypeEnum';

/**
 *
 * @export
 * @interface ChatMessage
 */
export interface ChatMessage {
    /**
     *
     * @type {number}
     * @memberof ChatMessage
     */
    readonly id: number;
    /**
     *
     * @type {number}
     * @memberof ChatMessage
     */
    chat: number;
    /**
     *
     * @type {MessageTypeEnum}
     * @memberof ChatMessage
     */
    messageType: MessageTypeEnum;
    /**
     *
     * @type {string}
     * @memberof ChatMessage
     */
    content: string;
    /**
     *
     * @type {Date}
     * @memberof ChatMessage
     */
    readonly createdAt: Date;
    /**
     *
     * @type {string}
     * @memberof ChatMessage
     */
    readonly responseTaskId: string;
    /**
     *
     * @type {string}
     * @memberof ChatMessage
     */
    readonly responseState: string;
    /**
     *
     * @type {number}
     * @memberof ChatMessage
     */
    readonly responseTo: number | null;
}



/**
 * Check if a given object implements the ChatMessage interface.
 */
export function instanceOfChatMessage(value: object): value is ChatMessage {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('chat' in value) || value['chat'] === undefined) return false;
    if (!('messageType' in value) || value['messageType'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('responseTaskId' in value) || value['responseTaskId'] === undefined) return false;
    if (!('responseState' in value) || value['responseState'] === undefined) return false;
    if (!('responseTo' in value) || value['responseTo'] === undefined) return false;
    return true;
}

export function ChatMessageFromJSON(json: any): ChatMessage {
    return ChatMessageFromJSONTyped(json, false);
}

export function ChatMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatMessage {
    if (json == null) {
        return json;
    }
    return {

        'id': json['id'],
        'chat': json['chat'],
        'messageType': MessageTypeEnumFromJSON(json['message_type']),
        'content': json['content'],
        'createdAt': (new Date(json['created_at'])),
        'responseTaskId': json['response_task_id'],
        'responseState': json['response_state'],
        'responseTo': json['response_to'],
    };
}

  export function ChatMessageToJSON(json: any): ChatMessage {
      return ChatMessageToJSONTyped(json, false);
  }

  export function ChatMessageToJSONTyped(value?: Omit<ChatMessage, 'id'|'created_at'|'response_task_id'|'response_state'|'response_to'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'chat': value['chat'],
        'message_type': MessageTypeEnumToJSON(value['messageType']),
        'content': value['content'],
    };
}

